/**
 * @warning This file is auto-generated by the `bun version:bump` script.
 * @warning Do not edit this file manually.
 * @see  `bun run version:bump` or bump-versiont.ts or use-version.ts or the pipelines for more information
* warme groentjes xx
*/
export const APP_VERSION = "0.0.5"
export const APP_VERSION_DISPLAY = `v${APP_VERSION}`
